import { render, staticRenderFns } from "./taskDtl.vue?vue&type=template&id=16792ad4&scoped=true&"
import script from "./taskDtl.vue?vue&type=script&lang=js&"
export * from "./taskDtl.vue?vue&type=script&lang=js&"
import style0 from "./taskDtl.vue?vue&type=style&index=0&id=16792ad4&prod&lang=scss&scoped=true&"
import style1 from "./taskDtl.vue?vue&type=style&index=1&id=16792ad4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16792ad4",
  null
  
)

export default component.exports